<template>
  <form action="#" class="my-uploaded"  method="post" enctype="multipart/form-data" ref="uploadForm" @change="uploadFile">
    <label for="myFileUpload" class="bg-light btn btn-secondary text-black" style="flex:none">上传文件</label>
    <input type="file" id="myFileUpload" :accept="accept" name="file" multiple hidden>
    <div class="list-box w-100 mt-2">
      <div class="flex mt-3 d-flex bg-light p-3" v-for="(file,index) of files" :key="index">
        <div class="filename me-2" :class="{'text-primary':file.status === 'success','text-danger':file.status === 'error'}">
         {{file.name}}
        </div>
        <!--    1, pending       -->
        <div class="fileState" v-if="file.status === 'pending'" title=" 等待上传">
          <span class="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true" ></span>
        </div>
        <!--    2, uploading       -->
        <div class="fileState" v-if="file.status === 'uploading'">
          <i class="bi bi-arrow-up me-1"></i> {{file.percent?file.percent:0}}%
        </div>
        <!--    3, success       -->
        <div class="fileState" v-if="file.status === 'success'">
          <button type="button" class="btn btn-outline-primary btn-sm" @click="removeFile(file)">
            移除
          </button>
<!--          <div style="font-size: 12px" class="mt-1 text-success">-->
<!--            <i class="bi bi-check"></i>-->
<!--            上传成功-->
<!--          </div>-->
        </div>
        <!--    4, error       -->
        <div class="fileState" v-if="file.status === 'error'" @click="removeFile(file)">
          <button type="button" class="btn btn-outline-primary btn-sm">
            移除
          </button>
          <div style="font-size: 12px" class="mt-1 text-danger">
            <i class="bi bi-exclamation"></i>
            上传失败
          </div>
        </div>
        </div>
      </div>
    <div v-if="tips" class="text-secondary mt-4" style="font-size: 0.8rem;text-align: left">
      {{tips}}
    </div>
  </form>

</template>

<script setup>


import {uploadImage} from "@/api/uploadFile";
const VUE_APP_uploadurl = process.env.VUE_APP_uploadurl
import {ref, onMounted,watch, defineProps, defineEmits, onUnmounted, onBeforeUnmount} from 'vue'
import {showToast} from "@/utils/toast";
import axios from "axios";
import {getToken} from "@/utils/token";

const uploadForm = ref()
const files = ref([
  // {name:"xxxx",status:"uploading"},
  // {name:"xxxx",status:"error"},
  // {name:"xxxx",status:"success"},
  // {name:"xxxx",status:"pending"}
]) // status:uploading,error,success,pending

//输入属性
const props = defineProps({
  fileList: {
    default: [] // {name:xxx,url:xxxxx,status:"uploading,error,success,pending",response:{data:url,err_code:0}},初始化status为success，response.data 必填
  },
  url: {
    default: "#"
  },
  accept: {
    default: ""
  },
  // accept="image/png"
  // accept=".png"
  // accept="image/png, image/jpeg"
  // accept=".png, .jpg, .jpeg"
  // accept="image/*"
  // accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  validFileTypes:{ // 需要验证的类型
    default: [] //["image/jpeg", "image/png"]
  },
  limit:{
    default: ""
  },
  fileSizelimit:{
    default: ""
  },
  tips:{
    default: ""
  },
})
// 输出属性
const emits = defineEmits({
  'update:fileList': (val) => {
    return val;
  }
})
watch(()=>props.fileList,(n,o)=>{
  if(n &&  Array.isArray(n) && n.length>0){
    n.forEach(item=>{
      const index = files.value.findIndex(f=>f.id===item.id)
      if(index<0){
        files.value.push({...item,id:new Date().getTime()})
      }
    })
  }else{
    files.value = []
  }
},{immediate:true})

//STEP 1 文件上传之前，文件类型和文件大小的判断
const beforeUpload = (fileObject,size)=>{
    // 验证文件类型
  let errorMessages = [];
  let isValidFileType = true
  if(props.validFileTypes && props.validFileTypes.length>0){
    const isValidFileType = props.validFileTypes.includes(fileObject.type);
    if (!isValidFileType) {
      errorMessages.push(`${fileObject.name}类型不符合上传要求`);
    }
  }
  //  是否要验证文件大小
  let isValidFileSize = true
    if(props.fileSizelimit){
      isValidFileSize = fileObject.size / 1024 / 1024 < size;
      !isValidFileSize && errorMessages.push(`${fileObject.name}文件超出${size}M!`);
    }
    return {
      isValid: isValidFileType && isValidFileSize,
      errorMessages: errorMessages.join("\n")
    };
}
// STEP 2 获取预览地址
const createObjectURL = (fileObj)=> {
  const image = URL.createObjectURL(fileObj);
  return image
}
// STEP 3: change file object into ArrayBuffer
const getArrayBuffer = (fileObj)=> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    // Get ArrayBuffer when FileReader on load
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    // Get Error when FileReader on error
    reader.addEventListener("error", () => {
      reject("error occurred in getArrayBuffer");
    });
    // read the blob object as ArrayBuffer
    // if you nedd Base64, use reader.readAsDataURL
    reader.readAsArrayBuffer(fileObj);
  });
}

// 检查限制照片
const isExceedLimited = (fileLength)=>{
  let currentFileLength = 0
  const addFileLength = fileLength - 0
  if(files.value){
    currentFileLength = files.value.length
  }
  if(props.limit && props.limit>0){
    if((currentFileLength + addFileLength )> props.limit){
      return true
    }else{
      return false
    }
  }else{
    return false
  }
}
// 移除fileList
const removeFile = (file)=>{
  const index = files.value.findIndex(item=>item.id === file.id)
  if(index>-1){
 files.value.splice(index,1)
  }
  console.log(files.value)
  // emits('update:fileList', files.value);
}
// 根据id找到index
const findIndexAndUpdata = (arr,id,updata)=>{
  const index = arr.findIndex(item=>item.id === id)
  if(index>-1){
    files.value[index] = {...files.value[index],...updata}
  }
  emits('update:fileList', files.value);
}
// 上传文件
const uploadFile =async (event)=>{
  try {
  let fs = event.target.files || {}
   if(isExceedLimited(fs.length)){
     return showToast("warning","超出文件上传数量限制！")
   }
  for(let index in fs){
    if(fs[index] && !isNaN(index)){
      const f = fs[index]
      let newFile = {}
      const {isValid,errorMessages} =  beforeUpload(f,5);
      if(!isValid){
        return showToast("warning",errorMessages)
      }
      newFile.id = new Date().getTime() // 给一个临时id
      newFile.name = f.name
      newFile.ArrayBuffer = await getArrayBuffer(f);
      newFile.ArrayBufferB = Array.from(new Uint8Array(f.ArrayBuffer))
      newFile.url = newFile.blob = createObjectURL(f) // 获取预览地址
      newFile.status = "pending"
      newFile.raw = f
      const fileSize =Math.floor(f.size / 1024 / 1024 * 100)/100
      newFile.fileSize = fileSize
      files.value.push(newFile)
      emits('update:fileList', files.value);
    }
  }
    toUpload() // 处理上传
  }catch (error){
    return showToast("err",error)
  }



  // const fileSize = this.files[0].size;
}
//  去上传
const toUpload =async ()=>{
  function getProcess(progressEvent,pf) {
    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    findIndexAndUpdata(files.value,pf.id,{"percent":percentCompleted})
  }
  for(let i=0;i<files.value.length;i++){
    let pf = files.value[i]
    if(pf.status === "pending"){
      let binary = new FormData()
      binary.append('file', pf.raw)
      binary.append('name', pf.name)
      files.value[i].percent = 0
      findIndexAndUpdata(files.value,pf.id,{status:"uploading"})
      const res = await uploadImage(binary,pf,getProcess)
      const resData = res.data || {}
      if (resData.err_code === 0) {
       findIndexAndUpdata(files.value,pf.id,{status:"success",response:resData})
      }else{
        findIndexAndUpdata(files.value,pf.id,{status:"error"})
      }
    }

  }
}


onMounted(()=>{

})
onBeforeUnmount(() => {

})
onUnmounted(()=>{

})

</script>

<style scoped lang="scss">
.my-uploaded{
  display: flex;
  flex-direction: column;
}
.my-uploaded >label {
  //background-color: indigo;
  padding: 0.5rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  display: inline-block;
  width: 120px;
  //margin-top: 1rem;
}
.list-box{
  width: 100%;
}
.filename{
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
}
.fileState{
  flex:none;
}
</style>
